import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateBrandIdentityGuideIdentity = unaryRpc({
  name: "updateBrandIdentityGuideIdentity",
  input: z.object({
    teamId: zExt.objectId(),
    name: z.string(),
    storefrontUrl: z.string(),
  }),
  output: z.object({ updated: z.boolean() }),
});
